import { call, put } from "redux-saga/effects";
import { authService } from "../services/authService";
import { authConstants } from "../actions/constants/authConstants";
import { commonConstants } from "../actions/constants/commonConstants";

// OTP: Send login code
function* otpLogin(action: any): any {
  try {
    const response = yield call(authService.otpLogin, action.payload);
    if (response.success) {
      yield put({ type: authConstants.otpLoginSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: authConstants.otpLoginFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.otpLoginFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error.errorMessage });
  }
}

function* otpVerify(action: any): any {
  try {
    const response = yield call(authService.otpVerify, action.payload);
    
    if (response.success) {
      yield put({ type: authConstants.otpVerifySuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: authConstants.otpVerifyFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.otpVerifyFailure, payload: error });
    yield put({ type: commonConstants.showMessageSuccess, payload: error.errorMessage });
  }
}


function* acceptInvitation(action: any): any {
  try {
    const response = yield call(authService.acceptInvitation, action.payload);
    if (response.success) {
      yield put({ type: authConstants.acceptInvitationSuccess, payload: response.resultObject });
    } else {
      yield put({ type: authConstants.acceptInvitationFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.acceptInvitationFailure, payload: error });
  }
}

// OTP: Resend code
function* resendOtp(action: any): any {
  try {
    const response = yield call(authService.resendOtp, action.payload);
    if (response.success) {
      yield put({ type: authConstants.resendOtpSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: authConstants.resendOtpFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.resendOtpFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error.errorMessage });
  }
}

// OTP: Resend code
function* renewToken(action: any): any {
  try {
    const response = yield call(authService.renewtoken, action.payload);
    if (response.success) {
      yield put({ type: authConstants.renewTokenSuccess, payload: response.resultObject });
    } else {
      yield put({ type: authConstants.renewTokenFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.renewTokenFailure, payload: error });
  }
}

function* verifyToken(action: any): any {
  try {
    const response = yield call(authService.verifyToken, action.payload);
    if (response.success) {
      yield put({ type: authConstants.verifyTokenSuccess, payload: response.resultObject });
    } else {
      yield put({ type: authConstants.verifyTokenFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.verifyTokenFailure, payload: error });
  }
}

function* registerTenant(action: any): any {
  try {
    const response = yield call(authService.registerTenant, action.payload);
    if (response.success) {
      yield put({ type: authConstants.registerTenantSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: authConstants.registerTenantFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.registerTenantFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error.errorMessage });
  }
}

function* verifyRegistration(action: any): any {
  try {
    const response = yield call(authService.verifyRegistration, action.payload);
    if (response.success) {
      yield put({ type: authConstants.verifyRegistrationSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: authConstants.verifyRegistrationFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.verifyRegistrationFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error.errorMessage });
  }
}

function* checkTenantExists(action: any): any {
  try {
    const response = yield call(authService.checkTenantExists, action.payload);
    if (response.success) {
      yield put({ type: authConstants.checkTenantExistsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: authConstants.checkTenantExistsFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.checkTenantExistsFailure, payload: error });
  }
}

export const otpAuthSaga = {
  otpLogin,
  resendOtp,
  acceptInvitation,
  verifyToken,
  renewToken,
  otpVerify,
  registerTenant,
  verifyRegistration,
  checkTenantExists,
};
